// https://stackoverflow.com/questions/5484578/how-to-get-document-height-and-width-without-using-jquery
// https://stackoverflow.com/a/5947840

import {Size} from './models';

export function documentSize(): Size {
  const width = Math.max(
    document.documentElement.clientWidth,
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth
  );
  const height = Math.max(
    document.documentElement.clientHeight,
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight
  );
  return {width: width, height: height};
}
